import React, { Suspense, lazy } from "react";
import Loading from "./components/Loading/Loading";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

const CssBaseline = lazy(()=>import("@material-ui/core/CssBaseline"));

const Navbar = lazy(()=>import("./components/Navbar/Navbar"));

const MainPage = lazy(()=>import("./pages/MainPage/MainPage"));

const theme = createTheme({
  palette: {
    common: {
      white: "#f0f0f5",
      black: "#040118",
    },
    primary: {
      main: "#4783fb",
    },
    secondary: {
      main: "#d6df2a",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
});

function App() {
  return (
    <Suspense fallback={<Loading />}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Navbar />
        <MainPage />
      </ThemeProvider>
    </Suspense>
  );
}

export default App;
